<template>
    <div>
        <b-modal
                id="keyboard-shortcuts"
                ref="keyboard-shortcuts"
                centered
                ok-only
                size="lg"
                ok-title="סגור"
                ok-variant="secondary" no-stacking>
            <template slot="modal-header">
                <div>
                    <span class="modal-header-title">קיצורי מקלדת</span></div>
            </template>
            <div class="keyboard-shortcuts-content">
                <div v-for="(lineDataSet, li) in lineDataSets" 
                        :key="'shortcut-line-'+(li+1)"
                        class="row align-content-center py-2"
                        v-bind:class="{'lighted-row': li % 2 === 0}">
                    <div class="col-3">
                        <div class="d-flex">
                            <span v-for="(groupingItem, g) in lineDataSet.groupingItems" 
                                    :key="'grouping-item-'+li+'-'+g"
                                    :class="{'key-divider': groupingItem.type === 'divider'}">
                                <div v-if="groupingItem.type === 'group'" class="d-inline-flex align-items-center">
                                    <div v-for="(itemOfGroup, i) in groupingItem.itemsOfGroup" :key="'item-'+i+'-of-group-'+li+'-'+g">
                                        <button v-if="itemOfGroup.type === 'key'" type="button" class="btn btn-link keyboard-btn">{{ itemOfGroup.text }}</button>
                                        <button v-if="itemOfGroup.type === 'arrow-key'" type="button" class="btn btn-link keyboard-btn">
                                            <i class="fa fa-lg" v-bind:class="'fa-caret-'+itemOfGroup.direction"></i>
                                        </button>
                                        <span v-if="itemOfGroup.type === 'plus'" class="mx-1">+</span>
                                        <span v-if="itemOfGroup.type === 'text'">{{ itemOfGroup.text }}</span>
                                        <span v-if="itemOfGroup.type === 'pointer'" class="mx-1">
                                            <i class="fa" v-bind:class="'fa-angle-'+itemOfGroup.direction"></i>
                                        </span>
                                    </div>
                                </div>
                            </span>
                        </div>
                    </div>
                    <div class="col-9 align-self-center">
                        <p class="mb-0">{{ lineDataSet.explanationText }}
                            <span v-if="showingKeyboardDisplays && 'advancedKeyboardDisplay' in lineDataSet">
                                <b-button v-b-modal="'nikud-whole-keyboard-popup-'+lineDataSet.advancedKeyboardDisplay"
                                    size="sm" variant="link" class="text-primary px-1">תצוגה מקדימה</b-button>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </b-modal>
        <keyboard-keys-popup v-if="showingKeyboardDisplays" :which-keyboard="'old'"></keyboard-keys-popup>
        <keyboard-keys-popup v-if="showingKeyboardDisplays" :which-keyboard="'new'"></keyboard-keys-popup>
        <keyboard-keys-popup v-if="showingKeyboardDisplays" :which-keyboard="'blind'"></keyboard-keys-popup>
    </div>
</template>

<script>
import KeyboardKeysPopup from "./keyboard-keys-popup"
import {SimpleVsProConfig} from '@/simpleVsProConfig.js'

export default {
    name: 'KeyboardShortcuts',
    components: {KeyboardKeysPopup},
    data () {
        var lineDataSets = []
        lineDataSets.push({
            groupingItems: [
                /*
                { type: 'group', itemsOfGroup: [
                    { type: 'key', text: 'H' },
                    { type: 'key', text: 'G' }
                ] },
                { type: 'divider' },
                */
                { type: 'group', itemsOfGroup: [
                    { type: 'arrow-key', direction: 'right' },
                    { type: 'arrow-key', direction: 'left' }
                ] }
            ],
            explanationText: 'מעבר בין מילים'
        })
        if (!(SimpleVsProConfig.NAVIGATION_KEYS_FOR_WORDS_ONLY)) lineDataSets.push({
            groupingItems: [
                { type: 'group', itemsOfGroup: [
                    { type: 'key', text: 'N' },
                    { type: 'key', text: 'B' }
                ] }
            ],
            explanationText: 'מעבר בין אותיות'
        })
        lineDataSets.push({
            groupingItems: [
                { type: 'group', itemsOfGroup: [
                    { type: 'arrow-key', direction: 'down' },
                    { type: 'arrow-key', direction: 'up' }
                ] }
            ],
            explanationText: 'בחירה מרשימת אפשרויות ניקוד'
        })
        if (!(SimpleVsProConfig.NAVIGATION_KEYS_FOR_WORDS_ONLY)) {
            lineDataSets.push({
                groupingItems: [
                    { type: 'group', itemsOfGroup: [
                        { type: 'arrow-key', direction: 'down' },
                        { type: 'arrow-key', direction: 'up' },
                        { type: 'plus' },
                        { type: 'text', text: 'Shift' }
                    ] }
                ],
                explanationText: 'מעבר בין שורות'
            })
            lineDataSets.push({
                groupingItems: [
                    { type: 'group', itemsOfGroup: [
                        { type: 'arrow-key', direction: 'down' },
                        { type: 'arrow-key', direction: 'up' },
                        { type: 'plus' },
                        { type: 'text', text: 'Shift' },
                        { type: 'plus' },
                        { type: 'text', text: 'Ctrl' }
                    ] }
                ],
                explanationText: 'מעבר בין פסקאות'
            })
        }
        lineDataSets.push({
            groupingItems: [
                { type: 'group', itemsOfGroup: [
                    { type: 'key', text: 'Backspace' }
                ] },
                { type: 'divider' },
                { type: 'group', itemsOfGroup: [
                    { type: 'key', text: 'Del' }
                ] }
            ],
            explanationText: 'מחיקת אות / ניקוד'
        })
        lineDataSets.push({
            groupingItems: [
                { type: 'group', itemsOfGroup: [
                    { type: 'key', text: 'i' },
                    { type: 'plus' },
                    { type: 'text', text: 'Ctrl' }
                ] }
            ],
            explanationText: 'מחיקת ניקוד מכל המילה'
        })
        if (SimpleVsProConfig.USE_LETTER_ADDING_MODE) lineDataSets.push({
            groupingItems: [
                { type: 'group', itemsOfGroup: [
                    { type: 'key', text: 'אות' },
                    { type: 'pointer', direction: 'right' },
                    { type: 'key', text: 'Space' }
                ] }
            ],
            explanationText: 'הוספת אות בודדת'
        })
        if (SimpleVsProConfig.USE_MULTIPLE_NIKUD_KEYBOARDS) {
            lineDataSets.push({
                groupingItems: [
                    { type: 'group', itemsOfGroup: [
                        { type: 'key', text: 'O' },
                        { type: 'plus' },
                        { type: 'text', text: 'Shift' }
                    ] }
                ],
                explanationText: 'שיטת ניקוד חדשה (אותיות)',
                advancedKeyboardDisplay: 'new'
            })
            lineDataSets.push({
                groupingItems: [
                    { type: 'group', itemsOfGroup: [
                        { type: 'key', text: 'L' },
                        { type: 'plus' },
                        { type: 'text', text: 'Shift' }
                    ] }
                ],
                explanationText: 'שיטת ניקוד ישנה (מספרים)',
                advancedKeyboardDisplay: 'old'
            })
            lineDataSets.push({
                groupingItems: [
                    { type: 'group', itemsOfGroup: [
                        { type: 'key', text: 'B' },
                        { type: 'plus' },
                        { type: 'text', text: 'Alt' },
                        { type: 'plus' },
                        { type: 'text', text: 'Shift' }
                    ] }
                ],
                explanationText: 'שיטת ניקוד בהקלדה עיוורת',
                advancedKeyboardDisplay: 'blind'
            })
        }
        if (SimpleVsProConfig.EDIT_NIKUD_POPUP.PRESENT) {
            lineDataSets.push({
                groupingItems: [
                    { type: 'group', itemsOfGroup: [
                        { type: 'key', text: 'E' },
                        { type: 'plus' },
                        { type: 'text', text: 'Ctrl' }
                    ] }
                ],
                explanationText: 'עריכת מילה'
            })
        }
        lineDataSets.push({
            groupingItems: [
                { type: 'group', itemsOfGroup: [
                    { type: 'key', text: 'K' },
                    { type: 'plus' },
                    { type: 'text', text: 'Shift' }
                ] }
            ],
            explanationText: (SimpleVsProConfig.NIKUD_BUTTONS.CAN_SHOW_OR_HIDE
                                ? 'פתיחה/סגירה של מקלדת ניקוד'
                                : 'פתיחת מקלדת ניקוד ידני')
        })
        if (!(SimpleVsProConfig.NO_KEYBOARD_NIKUD_AT_ALL)) lineDataSets.push({
            groupingItems: [
                { type: 'group', itemsOfGroup: [
                    { type: 'key', text: '/' },
                    { type: 'plus' },
                    { type: 'text', text: 'Ctrl' }
                ] }
            ],
            explanationText: 'הוספת דגש לאות הראשונה'
        })
        lineDataSets.push({
            groupingItems: [
                // { type: 'group', itemsOfGroup: [
                //     { type: 'key', text: 'T' },
                //     { type: 'plus' },
                //     { type: 'text', text: 'Ctrl' }
                // ] },
                // { type: 'divider' },
                // { type: 'divider' },
                { type: 'group', itemsOfGroup: [
                    { type: 'key', text: 'T' },
                    { type: 'plus' },
                    { type: 'text', text: 'Shift' }
                ] }
            ],
            explanationText: 'הצגה והסתרת אימות קריאה'
        })
        if (!(SimpleVsProConfig.NO_KEYBOARD_NIKUD_AT_ALL)) lineDataSets.push({
            groupingItems: [
                { type: 'group', itemsOfGroup: [
                    { type: 'key', text: 'T' }
                ] }
            ],
            explanationText: 'סימון אות כאם קריאה'
        })
        lineDataSets.push({
            groupingItems: [
                { type: 'group', itemsOfGroup: [
                    { type: 'key', text: 'M' },
                    { type: 'plus' },
                    { type: 'text', text: 'Ctrl' }
                ] }
            ],
            explanationText: 'הצגת פרוט מרפולוגי'
        })
        lineDataSets.push({
            groupingItems: [
                { type: 'group', itemsOfGroup: [
                    { type: 'key', text: 'A' },
                    { type: 'plus' },
                    { type: 'text', text: 'Shift' }
                ] }
            ],
            explanationText: 'החל שינויים על כל הטקסט'
        })
        lineDataSets.push({
            groupingItems: [
                { type: 'group', itemsOfGroup: [
                    { type: 'key', text: 'C' },
                    { type: 'plus' },
                    { type: 'text', text: 'Ctrl' }
                ] }
            ],
            explanationText: 'העתקת טקסט'
        })
        lineDataSets.push({
            groupingItems: [
                { type: 'group', itemsOfGroup: [
                    { type: 'key', text: 'D' },
                    { type: 'plus' },
                    { type: 'text', text: 'Shift' }
                ] }
            ],
            explanationText: 'ייצוא קובץ'
        })
        lineDataSets.push({
            groupingItems: [
                { type: 'group', itemsOfGroup: [
                    { type: 'key', text: 'Z' },
                    { type: 'plus' },
                    { type: 'text', text: 'Ctrl' }
                ] }
            ],
            explanationText: 'ביטול פעולה'
        })
        lineDataSets.push({
            groupingItems: [
                { type: 'group', itemsOfGroup: [
                    { type: 'key', text: 'Y' },
                    { type: 'plus' },
                    { type: 'text', text: 'Ctrl' }
                ] }
            ],
            explanationText: 'שחזור פעולה'
        })
        lineDataSets.push({
            groupingItems: [
                { type: 'group', itemsOfGroup: [
                    { type: 'key', text: '+' },
                    { type: 'plus' },
                    { type: 'text', text: 'Shift' }
                ] }
            ],
            explanationText: 'הגדלת טקסט'
        })
        lineDataSets.push({
            groupingItems: [
                { type: 'group', itemsOfGroup: [
                    { type: 'key', text: '-' },
                    { type: 'plus' },
                    { type: 'text', text: 'Shift' }
                ] }
            ],
            explanationText: 'הקטנת טקסט'
        })
        if (SimpleVsProConfig.IMPLEMENT_USER_ACCOUNTS) {
            lineDataSets.push({
                groupingItems: [
                    { type: 'group', itemsOfGroup: [
                        { type: 'key', text: 'Q' },
                        { type: 'plus' },
                        { type: 'text', text: 'Ctrl' }
                    ] }
                ],
                explanationText: 'הוספת מילה למאגר האישי'
            })
            lineDataSets.push({
                groupingItems: [
                    { type: 'group', itemsOfGroup: [
                        { type: 'key', text: 'X' },
                        { type: 'plus' },
                        { type: 'text', text: 'Shift' }
                    ] }
                ],
                explanationText: 'סימון מילה כמילה פגומה'
            })
        }
        return {
            lineDataSets: lineDataSets
        }
    },
    computed: {
        showingKeyboardDisplays () {
            return SimpleVsProConfig.SHOW_KEYBOARD_DISPLAYS
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .keyboard-btn {
        border: 1px solid #D1D0D0;
        border-radius: 3px;
        padding: 4px 8px;
        min-width: 30px;
        height: 28px;
        font-size: 16px;
        line-height: 2px;
        background: #fff;
        box-shadow: 0 1px 0 0 rgba(0,0,0,.17);
        margin-left: 1px;
        cursor: text !important;
    }
    .keyboard-btn:focus, .keyboard-btn:active
    {
        box-shadow: 0 1px 0 0 rgba(0, 0, 0, .17) !important;
    }
    .key-divider{
        width: 1px;
        background: #E3E3E3;
        margin: 4px;
        height: 20px;
        vertical-align: middle;
    }
    .lighted-row {
        background: #F6F6F6;
    }
    .keyboard-shortcuts-content {
        height: 360px;
        overflow-y: auto;
        overflow-x: hidden;
        margin: 0 -15px;
        padding: 0 15px;
    }

</style>
